import {Component, Input, OnChanges} from '@angular/core';
import {Artifact} from '../../../shared/types/artifact';
import {ImageMetadata} from '@webmate-web-core/shared/api/rest/image.restapi';
import {ImageService} from '@webmate-web-core/shared/services/image.service';

@Component({
    selector: 'wm-screenshot-artifact',
    templateUrl: './screenshot-artifact.component.html',
    styleUrls: ['./screenshot-artifact.component.less']
})
export class ScreenshotArtifactComponent implements OnChanges {

    @Input()
    artifact: Artifact;

    @Input()
    summary?: boolean = false;

    meta: ImageMetadata;

    constructor(private imageService: ImageService) {}

    ngOnChanges() {
        if (this.artifact?.data['screenshotId']) {
            this.imageService.getImageMetadata(this.artifact.data['screenshotId']).subscribe(meta => this.meta = meta);
        }
    }

}
